const styles = () => ({
    root: {
        minWidth: 125,
    },
});

export default styles;
